import { IGambleState } from '@GFTypes/GameStoreTypes';

export const GAMBLE_STATE_DEFAULTS: IGambleState = {
    gambleRequested: false,
    pickedCard: -1,
    gambleValue: 0,
    saveValue: 0,
    winValue: 0,
    halfingCount: 0,
    tries: 0
};
